import {MENUS} from "../menu";

export const ROUTER_NAMES = {
    EVENTOINSCRICAO: 'Inscricões',
    MINHASINSCRICAO: 'Minhas Inscricões',
}

export default [
    {
        name: ROUTER_NAMES.EVENTOINSCRICAO,
        path: '/inscricoes',
        meta: {
            menu: MENUS.SISTEMA,
            searchAlias: 'Inscricões',
            searchDescription: 'Veja todas as Inscricões realizadas',
            searchTerms: ['inscricoes','evento'],
            hasRole: 'role/EventoInscricao'
        },
        component: () => import('@/views/EventoInscricao')
    },
    {
        name: ROUTER_NAMES.MINHASINSCRICAO,
        path: '/minhas-inscricoes',
        meta: {
            menu: MENUS.SISTEMA,
            searchAlias: 'Minhas Inscricões',
            searchDescription: 'Veja todas as suas Inscricões realizadas',
            searchTerms: ['inscricoes','evento'],
            hasRole: 'role/EventoInscricao'
        },
        component: () => import('@/views/EventoInscricao')
    },
]